import { render, staticRenderFns } from "./HomeDoc1.vue?vue&type=template&id=9a2f46ba&"
import script from "./HomeDoc1.vue?vue&type=script&lang=js&"
export * from "./HomeDoc1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports